import React, {useCallback} from 'react';
import {WebSocketOperationButton} from "../../components/web-socket/WebSocketOperationButton";
import {useNeighbourhoodStore} from "../../api/NeighbourhoodStore";
import EnvoyIcon from "../../components/icons/EnvoyIcon";
import {useDeskStore} from "../../api/DeskStore";
import {useOfficeStore} from "../../api/OfficeStore";

export default function EnvoySyncButton() {
    const loadDesks = useDeskStore(state => state.refresh);
    const loadNeighbourhoods = useNeighbourhoodStore(state => state.refresh);
    const loadOffices = useOfficeStore(state => state.refresh);

    const handleFinish = useCallback(() => {
        loadDesks();
        loadNeighbourhoods();
        loadOffices();
    }, [loadDesks, loadNeighbourhoods, loadOffices]);

    return (
        <WebSocketOperationButton
            endpoint="/api/operations/sync-envoy-neighbourhoods"
            description="Synchronize neighbourhood data from Envoy to the local database"
            actionButtonLabel="Envoy Sync"
            icon={<EnvoyIcon color="white"/>}
            onFinish={handleFinish}
        />
    );
}